<template>
  <div id="fusion_controller">
    <template v-if="has_access">
      <fusion-body key="fusion_controller_fusion_body" :set-configuration="tool_config" />
    </template>
    <p v-else class="text-center py-5 text-text-default select-none" style="min-height: 300px" @click="handleUnauthorizedClick">{{ $FUSunauthorizedMessage }}</p>
  </div>
</template>
<script>
import { mapStores } from 'pinia';
import { useMainStore } from '@store/main';
import FusionBody from '@components/Core/FusionBody.vue';

export default {
  props: {
    setConfiguration: {
      type: Object,
      required: false,
      default: null
    },
    setToken: {
      type: String,
      required: false,
      default: null
    },
  },
  components: {
    'fusion-body': FusionBody,
  },
  created() {
    // [FUS-548] Never print the bearer token itself — only whether one arrived.
    console.log('FusionController props:', {
      setConfiguration: this.$FUSredactSensitiveFields(this.setConfiguration),
      setToken: this.setToken ? '<present>' : this.setToken,
    });
    window.addEventListener('hashchange', this.updateHashParams);
    this.updateHashParams();

    this.tool_config = this.$FUSjsonCopy(this.setConfiguration);
    this.tool_config.Panels = this.panels_config;
    if(this.decoded_token)
      this.mainStore.token = this.decoded_token;

    // Initialise analytics and start Rey session once the token is available.
    // Chained so rey_session_started fires into a fully-initialised Analytics module.
    // Return the startReySession promise so future code added after this block can chain off
    // it — startReySession is async (IndexedDB reads for sibling-iframe adoption) and a dropped
    // promise would leave rey_session_id null during the async gap.
    const self = this;
    this.mainStore.initAnalytics().then(() => self.mainStore.startReySession());

    // Initialize theme system and watch for changes (e.g. via Vue DevTools)
    //TODO: DO WE NEED THIS? ALREADY HAVE IT IN MAIN. SAME WITH ABOVE SO MAYBE REMOVE
    this.mainStore.initTheme();
    this.mainStore.$subscribe((mutation, state) => {
      if (mutation.type === 'direct' && mutation.events?.key === 'theme') {
        this.mainStore._applyTheme();
      }
    });
  },
  beforeUnmount() {
    window.removeEventListener('hashchange', this.updateHashParams);
    this.mainStore.endReySession();
  },
  data() {
    return {
      vehicle_info: null,
      vehicle_actions: null,
      tool_config: null,
      token: null,
      hash_params: {},
    }
  },
  computed: {
    ...mapStores(useMainStore),
    user_access_info() {
      return this.mainStore.user_access_info;
    },
    mode() {
      return this.tool_config?.Mode || null;
    },
    page_type() {
      return this.tool_config?.PageType || null;
    },
    decoded_token() {
      if (!this.setToken || this.setToken === 'null')
        return null;
      
      return this.setToken;
    },
    has_access() {
      let fieldData = true;
      if (!this.decoded_token) {
        fieldData = false;
        this.$FUSlog('Fusion Access denied: setToken is missing', 'warn');
      }

      if (!Boolean(this.user_access_info)) {
        fieldData = false;
        this.$FUSlog('Fusion Access denied: UAI is missing', 'warn');
      }

      return fieldData;
    },
    panels_config() {
      return [];
    },
  },
  methods: {
    updateHashParams() {
      const hash = window.location.hash.substring(1);
      const params = new URLSearchParams(hash);
      const hashParams = {};
      for (const [key, value] of params.entries()) {
        hashParams[key] = value;
      }
      this.hash_params = hashParams;
    },
    handleUnauthorizedClick() {
      window.event_bus.$emit('UNAUTHORIZED-CLICK');
    },
  }
}
</script>
